var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppAppleStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41.5,
    height: 41.5,
    viewBox: "0 0 46 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "qoar59mpaa",
    d: "M0 0h44.504v44.504H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.818)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g9ktnnsmpb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qoar59mpaa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.504 22.252c0 12.29-9.962 22.252-22.252 22.252S0 34.541 0 22.252C0 9.962 9.962 0 22.252 0s22.252 9.963 22.252 22.252",
    fill: "#000",
    mask: "url(#g9ktnnsmpb)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.313 12.68c.876-1.13 1.54-2.73 1.3-4.362-1.433.099-3.107 1.016-4.084 2.21-.89 1.084-1.623 2.693-1.337 4.257 1.566.049 3.184-.89 4.12-2.105",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.276 17.335c-1.376-1.725-3.31-2.727-5.136-2.727-2.41 0-3.43 1.155-5.105 1.155-1.727 0-3.038-1.151-5.123-1.151-2.048 0-4.228 1.251-5.61 3.391-1.944 3.014-1.611 8.68 1.538 13.506 1.127 1.727 2.632 3.669 4.601 3.686 1.752.016 2.246-1.124 4.62-1.136 2.373-.014 2.823 1.15 4.572 1.132 1.97-.015 3.558-2.167 4.685-3.893.808-1.238 1.109-1.862 1.736-3.26-4.558-1.735-5.289-8.215-.778-10.703",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppAppleStore);
export default __webpack_public_path__ + "static/media/app_apple_store.3ab350cace410093ddcbbf9bf197793f.svg";
export { ForwardRef as ReactComponent };